import { ohrAxiosOpen } from '../httpInstance/http'

export const sendOtp = ({ phone_number }) =>
    ohrAxiosOpen.post(`/auth/send_otp/`, { phone_number })

export const verifyOtp = ({ phone_number, otp }) =>
    ohrAxiosOpen.post(`/auth/verify_otp/`, { phone_number, otp })

export const sendSignUpOtp = ({
    first_name,
    last_name,
    phone_number,
    parent_phone_number,
}) =>
    ohrAxiosOpen.post(`/oh_users/student/signup`, {
        first_name,
        last_name,
        phone_number,
        parent_phone_number,
    })

export const verifySignUpOtp = ({ phone_number, verification_code }) =>
    ohrAxiosOpen.post(`/oh_users/student/verify`, {
        phone_number,
        verification_code,
    })
